import { render } from "./TextBlock.vue?vue&type=template&id=1e816884"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__